<script>
import axios from "@/axios.js";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import moment from "moment";

export default {
  components: {},
  data() {
    return {};
  },
  computed: {
  },
  methods: {},
  created() {
    const obj = {
      date: moment().add(12, "hours").format("YYYY-MM-DD hh:mm:ss+02"),
      operationcategory: 8,
      isactive: true
    };
    this.$store
      .dispatch("operationList/createOperation", obj)
      .then(response => {
        console.log(response.data.id)
        this.$vs.notify({
          color: "success",
          title: "",
          text: "Correctly Started!"
        });
       this.$router.push("/outlay-edit/"+response.data.id).catch(() => {});
      })
      .catch(err => {
        this.$vs.notify({
          color: "alert",
          title: "An Error Occured!",
          text: "The Outlay was NOT added, please contact your dev"
        });
      });
  }
};
</script>

